// extracted by mini-css-extract-plugin
export default {"wrapper":"textarea_wrapper__f0xXY","textarea":"textarea_textarea__oafKE","disabled":"textarea_disabled__A0NtR"};